import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import RetailHero from './components/RetailHero';
import CategoryShopGrid from './components/CategoryShopGrid';
import QualityPromise from './components/QualityPromise';
import HowDeliveryWorks from './components/HowDeliveryWorks';
import FeaturedSKUs from './components/FeaturedSKUs';
import SubscriptionTeaser from './components/SubscriptionTeaser';
import RetailCTABand from './components/RetailCTABand';

export default function RetailPage() {
  return (
    <>
      <Navbar />
      <main>
        <RetailHero />
        <CategoryShopGrid />
        <QualityPromise />
        <HowDeliveryWorks />
        <FeaturedSKUs />
        <SubscriptionTeaser />
        <RetailCTABand />
      </main>
      <Footer />
    </>
  );
}